import request from '../request';

const serve = {
  addCarbonFootprint(params) {
    return request.post('/user-center/carbonFootprint/add', params);
  },
  queryDetailForSupplier(params) {
    return request.post(
      '/user-center/carbonFootprint/queryDetailForSupplier',
      params
    );
  },
  queryPageForSupplier(params) {
    return request.post(
      '/user-center/carbonFootprint/queryPageForSupplier',
      params
    );
  },
  removeCarbonFootprint(params) {
    return request.post('/user-center/carbonFootprint/remove', params);
  },
  // 新版碳足迹
  submit(params) {
    return request.post('/user-center/green/submit', params);
  },
  draft(params) {
    return request.post('/user-center/green/draft', params);
  },

  /**
   * 绿色低碳填报：获取碳足迹详情（草稿回显）
   * 与后端约定地址：GET /user-center/green/getDraft
   */
  getGreenCarbonFootprintDetail(params) {
    return request.fetch('/user-center/green/getDraft', params);
  },
  /** @deprecated 语义上请优先使用 getGreenCarbonFootprintDetail */
  getDraft(params) {
    return this.getGreenCarbonFootprintDetail(params);
  },

  queryPage(params, type = 'greenCarbonCert') {
    return request.post(`/user-center/${type}/queryPage`, params);
  },

  detail(params, type = 'greenCarbonCert') {
    return request.post(`/user-center/${type}/detail`, params);
  },
  update(params, type = 'greenCarbonCert') {
    return request.post(`/user-center/${type}/update`, params);
  },
  delete(params, type = 'greenCarbonCert') {
    return request.post(`/user-center/${type}/delete`, params);
  },
};

export default serve;
